<template>
  <div id="searchWidget">
    <input
      @keyup.enter="$emit('search', searchTerm)"
      v-model="searchTerm" type="text" placeholder="Search for name"
    />
    <div id="searchButton" @click="$emit('search', searchTerm)">
      <div id="searchIcon">&#9906;</div>
    </div>
  </div>
</template>

<style scoped>
#searchWidget {
  display: inline-flex;
  margin-left: 15px;
}
input[type=text] {
  padding:5px;
  border:2px solid black;
  border-radius: 0px;
}
input::placeholder {
  font-family: Arial, Helvetica, sans-serif;
}
#searchButton {
  border-top:2px solid black;
  border-bottom:2px solid black;
  border-right:2px solid black;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
#searchIcon {
  transform: rotate(-45deg);
}
</style>

<script>
export default {
  name: 'SearchWidget',
  data() {
    return {
      searchTerm: '',
    };
  },
};
</script>
